import commonApi from '@/api/api.common'
import productApi from '@/api/api.product'
import i18n from '@/locales/index'
export default [
  {
    type: 'input',
    placeholder: i18n.t('RecipeManage.listRecipeName'),
    filed: 'name',
    default: ''
    // query: commonApi.forbidden_select
  },
  {
    type: 'select',
    placeholder: i18n.t('RecipeManage.listPublishStatus'),
    filed: 'state',
    default: 'Y',
    options: [
      {
        code: 'Y',
        name: i18n.t('RecipeManage.listY')
      },
      {
        code: 'N',
        name: i18n.t('RecipeManage.listN')
      }
    ]
    //query: commonApi.forbidden_select
  },
  // {
  //   type: 'input',
  //   placeholder: i18n.t('RecipeManage.listRecipeId'),
  //   filed: 'code',
  //   default: ''
  // },
  {
    type: 'select',
    placeholder: i18n.t('RecipeManage.listApplicableModel'),
    filed: 'productId',
    default: '',
    multiple: true,
    clearable: true,
    query: productApi.product_select
    //multipleable:true,
  },
  {
    type: 'select',
    placeholder: i18n.t('RecipeManage.listRecipeType'),
    filed: 'typeId',
    default: '',
    query: commonApi.cookbook_type_select
  },

  {
    type: 'datepicker',
    placeholder: '',
    default: [],
    filed: 'daterange',
    params: {
      start: 'startTime',
      end: 'endTime'
    },
    startplh: i18n.t('RecipeManage.listUpdateTimeStart'),
    endplh: i18n.t('RecipeManage.listUpdateTimeStart')
  }
]
